import { Context, createContext, useContext } from 'react';

export interface IAppContext {
    withShadowInMobileHeader?: boolean,
    isScrollingUp?: boolean,
}

export const AppContext: Context<IAppContext> = createContext<IAppContext>({ isScrollingUp: true });

export const useAppContext = () => {
    return useContext(AppContext);
};
